import classNames from "classnames";
import type { ComponentProps, FC } from "react";

export const FormSection: FC<ComponentProps<"div">> = ({ className, ...props }) => (
  <div className={classNames("row form-standard", className)} {...props} />
);
